<template>
  <div>
    <b-card class="standardpage">

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="ihold_reset">*EVENTS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-danger">{{ gtotal }}</span>
        </b-nav-item>
        <!-- {{ zholdevents }} -->
        <b-nav-item v-if="zevent.eventcode" class="nav-pills-hover-effect border-secondary" small
          v-for="(zevent, index) in iholdevents" :key="zevent"
          @click="agent = null; slac = [], eventcode = [zevent.eventcode]" :active="zevent.eventcode == eventcode[0]">
          <span :id="'event_name_' + index" :class="zevent.eventcode == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zevent.eventcode"></span>
          <span :id="'event_count_' + index" class="ml-1 badge badge-danger">{{ zevent.count }}</span>

          <span v-if="parseFloat(zevent.aged) > 0" :id="'event_aged_' + index" class="ml-1 badge badge-danger">{{
            zevent.aged }}</span>

          <b-tooltip :target="'event_name_' + index" placement="top">{{ zevent.name }}</b-tooltip>

          <b-tooltip :target="'event_count_' + index" placement="top">{{ zevent.count }} booking forms(s) in
            total.</b-tooltip>

          <b-tooltip :target="'event_aged_' + index" placement="top">{{ zevent.aged }} booking forms(s) have been
            delayed in
            for
            longer
            than a
            week!</b-tooltip>
        </b-nav-item>
      </b-nav>
      <hr />

      <div v-if="!component">
        <b-nav class="pt-2 ml-2 mb-2" small pills>
          <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="ihold_reset">*SLACS*
            <span :id="'ihold_count_total'" class="ml-1 badge badge-danger">{{ gtotal }}</span>
          </b-nav-item>
          <b-nav-item v-if="zclient.slac" class="nav-pills-hover-effect border-secondary" small
            v-for="(zclient, index) in iholdclients" :key="zclient"
            @click="agent = null; eventcode = []; slac = [zclient.slac]" :active="zclient.slac == slac[0]">
            <span :id="'ihold_name_' + index" :class="zclient.slac == '*BLOCKED*' ? 'strong text-danger' : null"
              v-html="zclient.slac"></span>
            <!-- {{ zclient.slac }} -->
            <!-- <span class="ml-1 badge badge-orange">{{ zclient.count }} /<span :id="'ihold_client_' + index"
                  class="ml-1 badge badge-danger">{{ zclient.aged }}</span></span> -->
            <b-tooltip :target="'ihold_name_' + index" placement="top">{{ zclient.name }}</b-tooltip>
            <span :id="'ihold_count_' + index" class="ml-1 badge badge-danger">{{ zclient.count }}</span>
            <!-- /<span class="pl-1">/</span> -->
            <span v-if="parseFloat(zclient.aged) > 0" :id="'ihold_aged_' + index" class="ml-1 badge badge-danger">{{
              zclient.aged }}</span>
            <b-tooltip :target="'ihold_count_' + index" placement="top">{{ zclient.count }} booking forms(s) in
              total.</b-tooltip>
            <b-tooltip :target="'ihold_aged_' + index" placement="top">{{ zclient.aged }} booking forms(s) have been
              delayed in
              for
              longer
              than a
              week!</b-tooltip>
          </b-nav-item>
        </b-nav>

        <hr />

        <b-card-header class="pt-2 pb-2">
          <b-row>
            <b-col cols="auto" v-if="!iholdagents.find(o => o.agent == agent)">
              <span class="badge badge-danger text-2x pt-0 pb-1 ml-0">Select an agent to view inventory
                <span v-if="user.permissions.includes('conferma.admin')">
                  <span v-if="status.includes('ready')">
                    <i class="fa fa-check-square-o text-primary ml-1"></i>
                    <span class="ml-1 text-white">Ready</span>
                  </span>
                  <span v-if="status.includes('pending')">
                    <i class="fa fa-hourglass-half text-warning ml-1"></i>
                    <span class="ml-1 text-white">Pending</span>
                  </span>
                </span>
              </span>

            </b-col>
            <b-col cols="auto" class="text-right" v-else>

              <span class="badge badge-danger text-2x pt-0 pb-1"> {{iholdagents.find(o => o.agent ==
                agent) ? iholdagents.find(o => o.agent == agent).name : ""}}
                <span v-if="user.permissions.includes('conferma.admin')">
                  <span v-if="status.includes('ready')">
                    <i class="fa fa-check-square-o text-primary ml-1"></i>
                    <span class="ml-1 text-white">Ready</span>
                  </span>
                  <span v-if="status.includes('pending')">
                    <i class="fa fa-hourglass-half text-warning ml-1"></i>
                    <span class="ml-1 text-white">Pending</span>
                  </span>
                </span>
              </span>

            </b-col>
            <b-col class="text-right strong"> Count:
              <span id="ihold_ztotal" class="ml-1 badge badge-danger text-3x pt-0 pb-1">{{ ztotal }}</span>
              <b-tooltip target="ihold_ztotal" placement="top">Total of uninvoiced inventory lines waiting.</b-tooltip>
            </b-col>
          </b-row>
        </b-card-header>

        <!-- <b-card-header class="pt-2 pb-2">
          <b-row>
             <b-col cols="4" class="text-left text-sm-left pt-1">
            <i :class="ihold.icon" class="mr-1"></i>
            Booking Forms
          </b-col> 
            <b-col cols="auto" v-if="slac.length == 0">
              <span class="badge badge-white text-2x pt-0 pb-1">Select a client SL A/C code to view inventory</span>
            </b-col>
            <b-col class="text-right strong"> Total:
              <span id="ihold_ztotal" class="ml-1 badge badge-danger text-3x pt-0 pb-1">{{ ztotal }}</span>
              <b-tooltip target="ihold_ztotal" placement="top">Total of uninvoiced inventory lines waiting.</b-tooltip>
            </b-col>
          </b-row>
        </b-card-header> -->

        <div v-if="!component" class="mt-4 availtable datatable">
          <b-row>
            <b-col>
              <b-avatar-group v-for="(zdepartment, gindex) in departments" :key="gindex" size="34px" overlap="0"
                class="inline mr-1 mt-1 ml-2 text-center p-1 avatar_dept avatarbadge">
                <span class="text-primary pt-2 mr-1">{{ zdepartment }}</span>
                <div v-for="(zagent, index) in iholdagents.filter(a => a.department == zdepartment)" :key="index">
                  <span @click="change_agent(zagent.agent)" :id="zagent.agent + '_' + zagent.department + '_1'">
                    <b-avatar class="mr-1 z-auto" :text="zagent.agent" :badge="zagent.count"
                      badge-variant="danger"></b-avatar>
                  </span>
                  <b-tooltip :target="zagent.agent + '_' + zagent.department + '_1'" placement="bottom">{{ zagent.name
                    }}
                  </b-tooltip>
                </div>

              </b-avatar-group>
            </b-col>
          </b-row>

          <b-row class="excelsheetbuttons " no-gutters>
            <b-col>
              <span class="small text-primary">{{ message_count }}</span> </b-col>
          </b-row>

        </div>


        <b-card v-if="ihold.filter" class="w-100pct mb-3">
          <b-card-body class="py-0">

            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetravel" v-model="datetravel" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="false" @click="
                        datetravel = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker size="sm" v-model="datetravel" label-help hide-header locale="en-GB"
                      placeholder="Date Travel" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"></b-form-datepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!datetravel" @click="datetravel = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-form-group label="Type" label-for="type" label-cols="12">
                  <treeselect v-model="type" :clearable="true" :multiple="true" :options="options_type"
                    placeholder="Show all..."></treeselect>
                </b-form-group> -->

                <b-form-group label-cols="12" label="Type" label-size="sm">
                  <treeselect placeholder="Show all..." searchPromptText="Supplier Type..." v-model="type"
                    :clearable="true" :multiple="true" :options="options_suppliertype">
                  </treeselect>
                </b-form-group>

              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadBLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="RefNo ( Paste List )" label-for="id" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="id" v-model="referenceno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste ID (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="referenceno = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Source" label-size="sm">
                  <treeselect placeholder="Select source..." v-model="mssql" :clearable="false"
                    :options="options_source" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (min)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.min" :debounce="ihold.debounce" placeholder="(min)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.min"
                            @click="cost.min = null; cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (max)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.max" :debounce="ihold.debounce" placeholder="(max)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.max"
                            @click="cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="user.permissions.includes('conferma.admin')">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Agent" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="agent" placeholder="Agent" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group> </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Status" label-size="sm">
                      <treeselect placeholder="Select status..." v-model="status" :multiple="true" :clearable="false"
                        :disabled="true" :options="options_status" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <div class="px-3 mt-2 mb-2">
          <e-table classdivtable="availtable datatable w-100pct" refid="ihold" :busy="ihold.busy" :icon="ihold.icon"
            :selectmode="'none'" :showtoolbar="true" :showfab="false" :showsheets="false" :showrowcount="true"
            :showautoadd="false" :showpages="true" :offset="ihold.offset" :limit="ihold.limit" :page="ihold.page"
            :tools="ihold.tools" :badges="ihold.badges" :fields="ihold.fields" :items="ihold.items" @click="ihold_click"
            @select="ihold_select" @load="ihold_load">
          </e-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="ihold.selected" :config="cconfig" @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"></component>
      </div>
      <b-card-footer>
        <b-row class="mt-2">
          <b-col><span class="small" v-html="message"></span> </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Hhold",
  async mounted() {
    this.accessdenied();
    await this.ihold_reset()
    // await this.iholdclients_load()
    // this.agent = this.user.initials;
  },
  watch: {
    async referenceno() {
      await this.ihold_load();
    },
    async slac() {
      await this.ihold_load();
    },
    async blac() {
      await this.ihold_load();
    },
    async datetravel() {
      await this.ihold_load();
    },
    async type() {
      await this.ihold_load();
    },
    async eventcode() {
      await this.ihold_load();
    },
    async agent() {
      await this.ihold_load();
    },
    async status() {
      await this.ihold_load();
    },
    "cost.min": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (!this.cost.max) { this.cost.max = this.cost.min }
        await this.ihold_load(0)
      }
    },
    "cost.max": {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.ihold_load(0)
      }
    },
  },

  data() {
    return {
      busy: false,
      message: "",
      gtotal: 0,
      ztotal: 0,
      iholdclients: [],
      iholdevents: [],
      iholdagents: [],
      readonly: false,
      email: "",
      agent: "",
      eventcode: [],
      slac: [],
      blac: [],
      // datetravel: null,
      datetravel: {
        startDate: null,
        endDate: null,
      },
      cost: {
        min: null,
        max: null,
      },
      type: [],
      options_suppliertype: [],
      options_type: [
        { id: "AIR", label: "Air Ticketed" },
        { id: "LOW", label: "Low Cost" },
        { id: "HTL", label: "Hotels" },
        { id: "CAR", label: "Cars" },
        { id: "XFR", label: "Transfers" },
        { id: "RAI", label: "Rail/Eurostar" },
        { id: "BAG", label: "Baggage" },
        { id: "MTG", label: "Meetings" },
        { id: "OTH", label: "Other" },
        // { id: "BMD", label: "Business" },
        // { id: "visa", label: "Visa" },
      ],
      referenceno: [],
      agent: "null",
      status: ["submitted"],
      options_status: [
        { id: "submitted", label: "Submitted" },
        { id: "unsubmitted", label: "Unsubmitted" },
        // { id: "pending", label: "Pending" },
        // { id: "offline", label: "Offline" },
      ],
      mssql: true,
      options_source: [
        { id: false, label: "Booking Forms" },
        { id: true, label: "API" },
      ],
      ihold: {
        title: "Inventory",
        icon: "fa fa-balance-scale text-secondary",
        debounce: 1000,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        filter: false,
        tools: "go,filter",
        fields: [
          {
            key: "litem",
            label: "Bhold Inventory",
            type: "ibinvoice",
            class: "text-left w-90pct",
            clearable: "true",
          },
        ],
        badges: [],
        items: [],
        selected: [],
      },
    };
  },
  async mounted() {
    await this.accessdenied();
    try {
      const response = await this.$apollo.query({
        query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
      });
      // this.options_suppliertype = response.data.suppliertypes;
      this.options_suppliertype = response.data.suppliertypes.filter(o => o.faicon != '');
    } catch (error) {
      console.log(error);
    }
    await this.ihold_load(0);
  },
  methods: {
    accessdenied() {
      this.ihold.denied = [];
      if (!this.user.permissions.includes("ihold.delete")) {
        this.ihold.denied.push("delete");
      }
      if (!this.user.permissions.includes("ihold.save")) {
        this.ihold.denied.push("save");
      }
    },
    async change_agent(agent) {
      this.agent = agent
      await this.ihold_load();
    },
    async ihold_reset() {
      let state = this.ihold;
      state.items = []
      this.eventcode = []
      this.slac = []
      this.agent = null
      this.ztotal = 0

      await this.iholdevents_load()
      await this.iholdclients_load()
      await this.iholdagents_load()
    },
    async ihold_reload() {
      await this.iholdevents_load()
      await this.iholdclients_load()
      await this.iholdagents_load()
      await this.ihold_load();
    },
    async iholdagents_load() {
      let variables = {
        type: 'byagent',
        source: 'bhold',
        status: 'submitted',
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        eventcode: this.eventcode ? this.eventcode.join(",") : null,
        slac: this.slac ? this.slac.join(",") : null,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
                  query ihold_counts(
                    $type: String
                    $status: String
                    $source: String
                    $blac: String
                    $eventcode: String
                    $slac: String
                  ) {
                    ihold_counts(
                      type: $type
                      source: $source
                      status: $status
                      blac: $blac
                      eventcode: $eventcode
                      slac: $slac
                  ) {
                      count
                      agent
                      email
                      name
                      department
                  }
                  }
              `,
          variables,
        });

        this.iholdagents = response.data.ihold_counts;

        this.departments = [...new Set(this.iholdagents.map(a => a.department))].sort()

        this.ztotal = 0
        for (var i = 0; i < this.iholdagents.length; ++i) {
          this.ztotal += parseInt(this.iholdagents[i].count)
        }
      } catch (error) {
        console.log(error);
      }
    },

    async iholdevents_load() {
      let variables = {
        type: 'byevent',
        source: 'bhold',
        status: 'submitted',
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query ihold_counts(
                  $type: String
                  $source: String
                  $status: String
                  $blac: String
                  $agent: String
                ) {
                  ihold_counts(
                    type: $type
                    source: $source
                    status: $status
                    blac: $blac
                    agent: $agent
                ) {
                    count
                    aged
                    eventcode
                    name
                }
                }
            `,
          variables,
        });

        this.iholdevents = response.data.ihold_counts;
        // this.ztotal = 0
        // for (var i = 0; i < this.iholdclients.length; ++i) {
        //   this.ztotal += parseInt(this.iholdclients[i].count)
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async iholdclients_load() {
      let variables = {
        type: 'byclient',
        source: 'bhold',
        status: 'submitted',
        agent: this.agent ? this.agent : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
                query ihold_counts(
                  $type: String
                  $source: String
                  $status: String
                  $blac: String
                  $agent: String
                ) {
                  ihold_counts(
                    type: $type
                    source: $source
                    status: $status
                    blac: $blac
                    agent: $agent
                ) {
                    count
                    aged
                    slac
                    name
                }
                }
            `,
          variables,
        });

        this.iholdclients = response.data.ihold_counts;
        this.ztotal = 0
        for (var i = 0; i < this.iholdclients.length; ++i) {
          this.ztotal += parseInt(this.iholdclients[i].count)
        }
        if (!this.agent) {
          this.gtotal = this.ztotal
        }

      } catch (error) {
        console.log(error);
      }
    },
    async ihold_load(offset, limit, page) {

      if (this.iholdevents.length == 0) { await this.iholdevents_load() }
      if (this.iholdclients.length == 0) { await this.iholdclients_load() }
      if (this.iholdagents.length == 0) { await this.iholdagents_load() }

      let state = this.ihold;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      //NO WILDCARD SEARCHES
      if (
        !this.agent && this.slac.length == 0 && this.eventcode.length == 0

      ) {
        this.message = ""
        // "<span class='text-danger'>Please select an SL A/C, Event, TicketNo or Passenger.</span>";
        return;
      }


      state.busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
        type: this.type.length > 0 ? this.type.join(",") : null,
        datetravel: [
          this.datetravel.startDate
            ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
            : null,
          this.datetravel.endDate
            ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
            : null,
        ],
        agent: this.agent,
        source: 'bhold',
        status: 'submitted',
        cost: this.cost.min ? [this.cost.min, this.cost.max] : null,
        // account_id: 'BF6B8347-749C-488A-9F5F-B6328E3DA1B3'
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
              query ihold(
                $mssql: Boolean
                $offset: Int
                $limit: Int
                $eventcode: String
                $slac: String
                $type: String
                $datetravel: [String]
                $blac: String
                $referenceno: String
                $status: String
                $source:String
                $agent:String
                $cost: [String]
              ) {
                ihold(
                  mssql: $mssql
                  offset: $offset
                  limit: $limit
                  eventcode: $eventcode
                  slac: $slac
                  type: $type
                  datetravel: $datetravel
                  blac: $blac
                  referenceno: $referenceno
                  status: $status
                  source: $source
                  agent: $agent
                  cost: $cost
                ) {
                  id
                  referenceno
                  eventcode
                  eventname
                  slac
                  slacname
                  yourref
                  cost
                  sale
                  vat
                  total
                  invoiceno
                  posted
                  agent
                  lines {
                    id
                    type
                    eventcode                  
                    slac                  
                    referenceno
                    routing
                    remark    
                    start_at
                    end_at
                    details
                    description
                    passenger
                    qty
                    sale
                    vat
                    vatr
                    markup
                    total                
                    cost
                    blac
                    payby
                    costcurrency
                    margin
                    agent
                    agentname
                    notes
                    expanded
                    claimed
                  }
                  tags
                  data
                  rows
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.ihold
        } else {
          state.items = []
          // STABLE ROW IDENTITY (tp_server#20): key each row by its line ids so
          // e-table keys rows by record, not position - prevents inline-editor
          // state bleeding onto other rows when paging.
          response.data.ihold.forEach(row => {
            let ids = [];
            (row.lines || []).forEach(l => { if (l.id != null) ids.push(l.id); });
            row.uid = [...new Set(ids)].sort().join('-');
          });
          state.items = response.data.ihold;
        }

      } catch (error) {
        console.log(error);
      }

      await this.iholdclients_load()
      await this.iholdagents_load()

      state.busy = false;
    },

    async ihold_click(a, ss) {
      console.log("ihold_click", a, ss);
      switch (a) {
        case "filter":
          this.ihold.filter = !this.ihold.filter;
          break;
        case "back":
          this.discard();
          break;
        case "save":
          this.saveit();
          break;
        case "posted":
          this.postit(ss);
          break;
        case "go":
          await this.ihold_reload();
          // await this.iholdclients_load()
          // await this.ihold_load();
          break;
      }
    },
    async ihold_select(ss, tools) {
      console.log("ihold_click", ss);

      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "autoquery", "filter", "export"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
        tool = tools.find((o) => o.action == "notes");
        if (tool) {
          tool.disabled = ss.length == 1 ? false : true;
        }
      }

      this.ihold.selected = ss;
    },
    async postit(s) {
      console.log("postit", s);
      s[0].posted = true
      await this.iholdclients_load()
      this.$store.dispatch("bookingforms");
    },

  },
};
</script>